const EmployeeDiscountModuleHome = () => (
  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="72" height="72" rx="14.5455" fill="url(#paint0_linear_4717_38210)" />
    <g clip-path="url(#clip0_4717_38210)">
      <path
        d="M36.44 19.665C36.99 19.83 37.43 19.995 37.87 20.38C38.31 20.765 39.795 22.415 40.29 22.635C40.785 22.855 40.565 22.69 40.73 22.69C42.215 22.69 43.81 21.865 45.24 22.635C46.67 23.405 46.725 25.66 47.11 27.31C47.495 28.96 47.605 28.025 48.1 28.355C49.64 29.235 51.565 29.73 51.565 31.875C51.565 33.25 50.3 34.515 50.025 35.725C49.75 36.935 50.025 36.44 50.245 36.88C50.905 38.365 52.06 39.575 51.345 41.335C50.63 43.095 48.87 43.205 47.605 44.03C46.34 44.855 47.165 44.36 47.055 44.8C46.725 46.175 46.835 48.045 45.735 49.09C44.635 50.135 42.38 49.475 40.62 49.42C38.86 49.365 40.125 49.475 39.85 49.695C38.75 50.575 37.76 52.225 36.22 52.39C34.68 52.555 33.855 51.565 32.865 50.63C31.875 49.695 31.875 49.365 31.105 49.365C29.4 49.42 27.64 50.41 26.1 49.09C24.89 48.1 25.055 46.175 24.725 44.745C24.395 43.315 24.23 44.03 23.735 43.7C22.58 43.04 20.985 42.6 20.49 41.225C19.995 39.85 20.985 38.31 21.59 36.825C22.195 35.34 21.92 36.165 21.81 35.67C21.535 34.46 20.215 33.195 20.27 31.82C20.27 29.62 22.195 29.18 23.735 28.3C25.275 27.42 24.56 27.915 24.725 27.255C25.165 25.605 24.89 23.515 26.595 22.58C28.3 21.645 29.62 22.58 31.105 22.635C32.59 22.69 31.38 22.635 31.545 22.58C32.04 22.415 33.415 20.765 33.965 20.325C34.515 19.885 34.845 19.775 35.395 19.61H36.275L36.44 19.665ZM31.985 27.53C29.235 27.75 27.805 31.105 29.62 33.195C31.435 35.285 33.965 34.735 35.175 32.7C36.385 30.665 34.68 27.31 31.93 27.53H31.985ZM42.05 28.85C41.885 28.85 41.72 28.96 41.61 29.07L29.07 41.61C28.465 42.49 29.455 43.535 30.39 42.93L42.985 30.335C43.48 29.62 42.985 28.74 42.05 28.85ZM39.245 37.595C38.145 37.76 36.99 38.695 36.605 39.685C35.395 42.93 39.025 45.735 41.775 43.81C44.69 41.72 42.875 37.155 39.245 37.595Z"
        fill="white"
      />
      <path
        d="M33.36 32.095C31.985 33.47 29.84 31.6 30.94 30.06C32.04 28.52 34.9 30.5 33.36 32.095Z"
        fill="white"
      />
      <path
        d="M38.64 39.905C40.015 38.53 42.16 40.4 41.06 41.94C39.96 43.48 37.1 41.5 38.64 39.905Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4717_38210"
        x1="35.5325"
        y1="2.5289e-06"
        x2="91.0286"
        y2="43.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6600E8" />
        <stop offset="1" stop-color="#BD0044" />
      </linearGradient>
      <clipPath id="clip0_4717_38210">
        <rect width="33" height="33" fill="white" transform="translate(19.5 19.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default EmployeeDiscountModuleHome
